<div class="loginContainer">
  <div class="containerInfo">
    <div class="productionLogikImage">
      <img src="/assets/img/production_logik.gif" alt="Production logik">
    </div>
    @if (!getToken) {
      @if (!sendForm) {
        <form [formGroup]="tokenForm" class="form-login" (ngSubmit)="submitForm()">
          <input formControlName="email"  type="text" name="email" [placeholder]="'EMAIL' | translate">
          <button [disabled]="tokenForm.invalid" class="loginlink">{{'Generate token' | translate}}</button>
          <a [class.disabled]="tokenForm.controls['email'].invalid" (click)="tokenForm.controls['email'].valid && changeView('token')">{{ 'I already have a token'  | translate }}</a>
        </form>
      }
    } @else {
      <form ngNoForm method="POST" [action]="actionForm" class="form-login">
        @if (getMessage) {
          <span class="success-message">{{getMessage | translate}}</span>
        }
        @if (tokenError) {
          <span class="error-message">{{tokenError | translate}}</span>
        }
        <input type="hidden" name="email" [value]="email">
        <input [(ngModel)]="token" type="password" name="token" [placeholder]="'TOKEN' | translate">
        <button  [disabled]="!token" class="loginlink">{{'Login' | translate}}</button>
        <a (click)="changeView('email')">{{ 'Request new Token' | translate }}</a>
      </form>
    }



    @if (sendForm) {
      @if (getError) {
        <p>{{ getError | translate }}</p>
      }
    }
  </div>
</div>
